<!-- src/layouts/default.vue -->
<template>
    <div class="default-layout">
        <div class="main_page">
            <router-view></router-view>
        </div>
    </div>
</template>
  
<script>
export default {}
</script>
  
<style scoped>
.default-layout {
    display: flex;
    /* flex-direction: column; */
    min-height: 100vh;
}

.main_page {
    flex: 1;
    padding: 0;
}
</style>